/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EdrDeploymentTypeEnum = 'ON_PREM';

export const EdrDeploymentTypeEnum = {

    ON_PREM: 'ON_PREM' as EdrDeploymentTypeEnum
};

